import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=afb54f38&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afb54f38')) {
      api.createRecord('afb54f38', component.options)
    } else {
      api.reload('afb54f38', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=afb54f38&", function () {
      api.rerender('afb54f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/Loading.vue"
export default component.exports